export default __webpack_public_path__ + "img/5c033234e45707b7bc6137c067a40c4e.svg";